import { createSlice } from '@reduxjs/toolkit'
import {
  notificationInboxResetAlertHandler,
  getNotificationsInboxBell,
  notificationsInboxActions,
  retrieveNotificationInboxWithQueries,
  retrieveNotificationInboxDetails,
  retrieveNotificationInboxHistory,
  NotificationsInboxActionsBulk,
} from './notificationInboxThunk'
import { updateStateFromQueries } from '../../../../utils/helpers'

const defaultPageSize = 9
const defaultActiveSummary = 'ALL'

const initialState = {
  loading: {
    fetch: false,
    mutate: false,
  },
  alert: {},
  pageNumber: 0,
  summaries: {},
  sortList: [],
  activeSort: {},
  filterList: [],
  activeFilters: {},
  pageSize: defaultPageSize,
  activeSummary: defaultActiveSummary,
  activeSearch: '',
  data: [],
  lookups: {},
  updatedItem: {},
  finalPage: true,
  notificationsBell: {},
  detailsRequest: [],
  requestHistory: [],
  systemRequestHistory: null,
}

const notificationInboxSlice = createSlice({
  name: 'notificationInbox',
  initialState,

  extraReducers: (builder) => {
    builder.addCase(notificationInboxResetAlertHandler.fulfilled, (state) => {
      state.alert = {}
    })

    builder.addCase(
      retrieveNotificationInboxWithQueries.pending,
      (state, { meta: { arg: { queries } } }) => {
        state.loading.fetch = true
        state.alert = {}
        state.pageNumber = queries?.pageNumber ? queries?.pageNumber : 0
        if (!queries?.pageNumber) {
          state.data = []
        }
      },
    )

    builder.addCase(retrieveNotificationInboxWithQueries.rejected, (state, { payload }) => {
      state.loading.fetch = false
      state.alert = payload
    })

    builder.addCase(retrieveNotificationInboxWithQueries.fulfilled, (state, { payload }) => {
      const { response, queries } = payload
      state.data = queries?.pageNumber === 0 ? response.data : [...state.data, ...response.data]
      state.finalPage = response?.data?.length < state.pageSize
      state.summaries = response?.metadata
      state.updatedItem = {}
      state.pageNumber = 0
      state.alert = {}
      state.loading.fetch = false

      updateStateFromQueries(state, queries)
    })

    builder.addCase(notificationsInboxActions.pending, (state) => {
      state.loading.mutate = true
      state.alert = {}
    })

    builder.addCase(notificationsInboxActions.rejected, (state, { payload }) => {
      state.loading.mutate = false
      state.alert = payload
    })

    builder.addCase(notificationsInboxActions.fulfilled, (state) => {
      state.loading.mutate = false
      state.alert = {}
    })

    builder.addCase(getNotificationsInboxBell.pending, (state) => {
      state.loading.fetch = true
      state.notificationsBell = {}
      state.alert = {}
    })

    builder.addCase(getNotificationsInboxBell.rejected, (state, { payload }) => {
      state.loading.fetch = false
      state.alert = payload
    })

    builder.addCase(getNotificationsInboxBell.fulfilled, (state, { payload }) => {
      state.notificationsBell = payload
      state.loading.fetch = false
    })
    builder.addCase(retrieveNotificationInboxDetails.pending, (state) => {
      state.loading.fetch = true
      state.alert = {}
    })

    builder.addCase(retrieveNotificationInboxDetails.rejected, (state, { payload }) => {
      state.loading.fetch = false
      state.alert = payload
    })

    builder.addCase(retrieveNotificationInboxDetails.fulfilled, (state, { payload }) => {
      state.detailsRequest = payload
      state.loading.fetch = false
      state.alert = {}
    })

    builder.addCase(retrieveNotificationInboxHistory.pending, (state) => {
      state.loading.fetch = true
      state.alert = {}
    })
    builder.addCase(retrieveNotificationInboxHistory.rejected, (state, { payload }) => {
      state.loading.fetch = false
      state.alert = payload
    })
    builder.addCase(retrieveNotificationInboxHistory.fulfilled, (state, { payload }) => {
      state.requestHistory = payload.data
      state.systemRequestHistory = payload.system_tracking
      state.loading.fetch = false
      state.alert = {}
    })
    builder.addCase(NotificationsInboxActionsBulk.pending, (state) => {
      state.loading.mutate = true
      state.alert = {}
    })

    builder.addCase(NotificationsInboxActionsBulk.rejected, (state, { payload }) => {
      state.loading.mutate = false
      state.alert = payload
    })

    builder.addCase(NotificationsInboxActionsBulk.fulfilled, (state) => {
      state.loading.mutate = false
      state.alert = {}
    })
  },
})

export const selectNotificationInbox = ({ notificationInbox }) => notificationInbox

export default notificationInboxSlice.reducer
